import dimbox from 'dimbox';
import { getCookie, isSupportCookieStore } from '../shared/functions';
import constants from '../shared/constants';

document.addEventListener('DOMContentLoaded', async (): Promise<void> => {
    dimbox.setConfig({
        showDownloadButton: false,
        showFullscreenButton: false,
        iframeTemplate: '<div class="dimbox-iframe-container"><iframe src="{{src}}" class="dimbox-iframe" allow="autoplay; encrypted-media" allowfullscreen></iframe><div class="dimbox-caption">{{caption}}</div></div>',
        inlineTemplate: `<div class="dimbox-inline-container"><div class="dimbox-inline-content">{{content}}</div></div>`
    });

    const $videoPopups: NodeListOf<HTMLAnchorElement> = document.querySelectorAll<HTMLAnchorElement>('.video-popup, .dimbox-trigger--video');
    let videoPlayed: boolean = false;
    const cookieConsent: string = await getCookie(constants.cookies.consent);
    let hasConsent: boolean = cookieConsent === 'true';

    const syncVideoPopupHref = ($videoPopup: HTMLAnchorElement): void => {
        const originalHref: string | undefined = $videoPopup.dataset.videoSrc ?? $videoPopup.getAttribute('href') ?? undefined;
        const inlineTarget: string | undefined = $videoPopup.dataset.inlineTarget;

        if (!originalHref) return;

        $videoPopup.dataset.videoSrc = originalHref;
        $videoPopup.href = hasConsent || !inlineTarget ? originalHref : inlineTarget;
    };

    $videoPopups.forEach(($videoPopup: HTMLAnchorElement) => {
        syncVideoPopupHref($videoPopup);

        $videoPopup.addEventListener('click', (e: MouseEvent) => {
            e.preventDefault();

            syncVideoPopupHref($videoPopup);
            dimbox.open($videoPopup);

            if (hasConsent) {
                videoPlayed = true;
            }
        });
    });

    if (isSupportCookieStore) {
        (window as any).cookieStore.addEventListener('change', async (event: { changed: Array<{ name: string; value: string }>, deleted: Array<{ name: string }> }) => {
            const occChanged = event.changed.find(c => c.name === constants.cookies.consent);
            const occDeleted = event.deleted.find(c => c.name === constants.cookies.consent);

            if (occChanged || occDeleted) {
                hasConsent = occChanged?.value === 'true';
                $videoPopups.forEach(($videoPopup: HTMLAnchorElement) => syncVideoPopupHref($videoPopup));
                if (!cookieConsent && videoPlayed) window.location.reload();
            }
        });
    }
});
